<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="shrink-0"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <!-- Tuning Fork Prongs and Stem -->
    <!-- Left Prong -->
    <path d="M8 3V11C8 13.2091 9.79086 15 12 15" />
    <!-- Right Prong -->
    <path d="M16 3V11C16 13.2091 14.2091 15 12 15" />
    <!-- Stem / Handle -->
    <path d="M12 15V21" stroke-width="2.4" />
    <!-- Handle Base Dot / Finial -->
    <circle cx="12" cy="21" r="1.2" fill="currentColor" stroke="none" />

    <!-- Acoustic Resonance Waves / Vibration Hints -->
    <path d="M5 6C4.3 7.2 4 8.5 4 10" stroke-width="1.6" />
    <path d="M19 6C19.7 7.2 20 8.5 20 10" stroke-width="1.6" />
  </svg>
</template>

<script setup>
</script>
